// extracted by mini-css-extract-plugin
export var filterIncDec = "_dl-0";
export var leftBorder = "_dl-1";
export var rightBorder = "_dl-2";
export var stringInput = "_dl-3";